import { ref } from "vue";

export type ToastKind = "error" | "info" | "success";

export interface ToastEntry {
  id: number;
  kind: ToastKind;
  message: string;
  timeoutHandle: number | null;
  title?: string;
}

interface PushToastOptions {
  durationMs?: number;
  kind?: ToastKind;
  message: string;
  title?: string;
}

const DEFAULT_DURATION_MILLISECONDS = 4000;

const toasts = ref<ToastEntry[]>([]);
let nextId = 1;

function dismissToast(id: number) {
  const target = toasts.value.find((entry) => entry.id === id);
  if (target?.timeoutHandle !== null && target?.timeoutHandle !== undefined) {
    window.clearTimeout(target.timeoutHandle);
  }
  toasts.value = toasts.value.filter((entry) => entry.id !== id);
}

function pushToast(options: PushToastOptions): number {
  const id = nextId;
  nextId += 1;

  const durationMs = options.durationMs ?? DEFAULT_DURATION_MILLISECONDS;
  const entry: ToastEntry = {
    id,
    kind: options.kind ?? "info",
    message: options.message,
    timeoutHandle: durationMs > 0 ? window.setTimeout(() => dismissToast(id), durationMs) : null,
    title: options.title,
  };

  toasts.value = [
    ...toasts.value,
    entry,
  ];
  return id;
}

export function useToast() {
  return {
    dismissToast,
    pushToast,
    toasts,
  };
}
